import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled, { css } from 'styled-components';
import { Link, withRouter } from 'react-router-dom'
import { VelocityComponent } from 'velocity-react';
import { rgba } from 'polished';
import Fade from 'react-reveal/Fade';

import { media } from '../../styles/utils'
import { container, bgImage, bgIcon, padding, hoverState, Title } from '../../styles/global';

import ArrowRight from 'svg-react-loader?name=Icon!../../assets/icons/arrow-right-white.svg';

class LetterLinks extends Component<Props, State> {

    render() {

        return (
            <Letters>
                <LetterLink
                    to={'/letter/client'}
                    letterType={'client'}
                >
                    <Fade
                        duration={1000}
                        up
                    >
                        <Title>I'm a client</Title>
                        <LinkDescriptor>
                            {`Read the letter`.toUpperCase()}
                            <Arrow/>
                        </LinkDescriptor>
                    </Fade>
                </LetterLink>

                <LetterLink
                    to={'/letter/artist'}
                    letterType={'artists'}
                >
                    <Fade
                        duration={1000}
                        up
                    >
                        <Title>I'm an artist</Title>
                        <LinkDescriptor>
                            {`Read the letter`.toUpperCase()}
                            <Arrow/>
                        </LinkDescriptor>
                    </Fade>
                </LetterLink>
            </Letters>
        )
    }
}

const Letters = styled.div`
    display: flex;
    /* border-top: 1px solid ${rgba('black', 0.1)}; */

    ${media.phone`
        flex-direction: column; 
        padding-bottom: 60px;
    `}
`;

const LinkDescriptor = styled.div`
    display: flex;
    align-items: center;

    opacity: 0.33;
    font-family: 'Platform-Regular';
    font-size: 13px;
    color: #FFFFFF;
    letter-spacing: 2.04px;
    text-align: center;
`;

const Arrow = styled(ArrowRight)`
    margin-left: 5px;
    transform: translateY(-1px);
`

const LetterLink = styled(Link)`
    flex: 1%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #F5F5F5;


    &:first-child {
        border-right: 1px solid ${rgba('black', 0.1)};
    }

    .react-reveal {
        > * {
            transition: all 0.25s ease;
        }
    }

    &:hover {
        background: #9A66FE;
        
        ${Title} {
            color: white;
            transform: translateY(0);
        }

        ${LinkDescriptor} {
            opacity: 0.33;
        }
    }

    ${Title} {
        transform: translateY(20px)
    }

    ${LinkDescriptor} {
        opacity: 0;
    }

    ${media.phone`
        height: calc(50vh - 30px);

        &:first-child {
            border-bottom: 1px solid ${rgba('black', 0.1)};
        }

        ${Title} {
            font-size: 40px;
        }
    `}

    ${props => {
        if (props.letterType == 'client') return css`
            &:hover {
                background: #DB5537;     
            }
        ` 
    }}
`;

const mapDispatchToProps = dispatch => ({

})

const mapStateToProps = (state, props) => ({

})

export default connect(mapStateToProps, mapDispatchToProps)(LetterLinks);



// WEBPACK FOOTER //
// ./client/components/LetterLinks/LetterLinks.js